const aLogoEdition = {
  aLogoEdition: {
    academia: {
      label: 'Logo de Academia',

      messages: {
        dimensions: '* Tamaño sugerido de imagen: 173px de ancho por 41px de alto',
        extensions: '* Formatos permitidos de imagen: .gif .jpg .png'
      },

      tooltipModify: 'Modificar'
    },

    changeLogo: 'cambiar logo',

    punto_venta: {
      label: 'Logo de Comprobante',

      messages: {
        dimensions: '* Tamaño sugerido de imagen: 200px de ancho por 200px de alto',
        extensions: '* Formatos permitidos de imagen: .png'
      },
      tooltip: 'El logo de comprobante se mostrará en el comprobante de venta.',
      tooltipModify: 'Modificar'
    },

    validation: {
      file: {
        extension: 'Extensión de imagen no permitida.',
        size: 'Tamaño de imagen no permitido.'
      }
    }
  }
}

export default aLogoEdition
